/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Review.Api
 * OpenAPI spec version: 1.0
 */

export type TaxReturnItemType = (typeof TaxReturnItemType)[keyof typeof TaxReturnItemType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaxReturnItemType = {
    Unknown: 'Unknown',
    DataEntryRoot: 'DataEntryRoot',
    DataEntryBundleReportBranch: 'DataEntryBundleReportBranch',
    DataEntryWorkpapersBranch: 'DataEntryWorkpapersBranch',
    DataEntryWorksheetsBranch: 'DataEntryWorksheetsBranch',
    DataEntryWorksheetFolder: 'DataEntryWorksheetFolder',
    DataEntryWorksheet: 'DataEntryWorksheet',
    ReportsRoot: 'ReportsRoot',
    ReportsCalcNameBranch: 'ReportsCalcNameBranch',
    ReportsFormsBranch: 'ReportsFormsBranch',
    ReportsFormBranch: 'ReportsFormBranch',
    ReportsFormPage: 'ReportsFormPage',
    ReportsEcoFormPage: 'ReportsEcoFormPage',
    ReportsStatementsBranch: 'ReportsStatementsBranch',
    ReportsCalculation: 'ReportsCalculation',
    ReportsAttachment: 'ReportsAttachment',
    ReportsCalculationsBranch: 'ReportsCalculationsBranch',
    ReportsNotes: 'ReportsNotes',
    ReportsWhitepaperReport: 'ReportsWhitepaperReport',
    AuditScreen: 'AuditScreen',
    TraceScreen: 'TraceScreen',
    Statement: 'Statement',
    CalculationDetailStatementText: 'CalculationDetailStatementText',
    CalculationDetailStatementRow: 'CalculationDetailStatementRow',
    CalculationDetailStatementColumn: 'CalculationDetailStatementColumn',
    CalculationMARTStatement: 'CalculationMARTStatement',
    CalculationPartnershipStatement: 'CalculationPartnershipStatement',
    ImportDetailScreen: 'ImportDetailScreen',
    ExportDetailScreen: 'ExportDetailScreen',
    TaxReturnDataEntryScreen: 'TaxReturnDataEntryScreen',
    MassImportDetailScreen: 'MassImportDetailScreen',
    PassthroughGrouping: 'PassthroughGrouping',
    DetailGrid: 'DetailGrid',
    ValidationResultError: 'ValidationResultError',
    ValidationResultWarning: 'ValidationResultWarning',
    ValidationResultInfo: 'ValidationResultInfo',
    EfileDataEntryStatement: 'EfileDataEntryStatement',
    OpenXmlSpreadsheet: 'OpenXmlSpreadsheet',
    FormStatementXmlFile: 'FormStatementXmlFile',
    EcoFormDataEntryStatement: 'EcoFormDataEntryStatement',
    CategoryFolder: 'CategoryFolder',
    ReportsBranch: 'ReportsBranch',
    Report: 'Report',
    ReturnReferencesBranch: 'ReturnReferencesBranch',
    NextGenTraceScreen: 'NextGenTraceScreen',
    BasicOverflowReport: 'BasicOverflowReport',
} as const;
